import { agents } from '../data/agents';
import type { Agent, AgentId } from '../types/anna';

export function getAgent(id: AgentId): Agent {
  const agent = agents.find((a) => a.id === id);
  if (!agent) throw new Error(`Onbekende agent: ${id}`);
  return agent;
}
